import React from "react";

interface Props {
    state: Set<number>;
}

const getLineColor = (state: Set<number>, line: number): string => {
    if (state.size == 0) {
        return "grey";
    }
    if (state.has(line)) {
        return "green";
    }
    return "orange";
};

const ArticleTranslatorProgress: React.FC<Props> = ({ state }) => {
    const lines = [
        { title: "Title and headline", index: 1 },
        { title: "I. Paragraph", index: 2 },
        { title: "II. Paragraph", index: 3 },
        { title: "III. Paragraph", index: 4 },
        { title: "IV. Paragraph", index: 5 },
    ];

    return (
        <div>
            <div>Progress Tracker</div>
            {lines.map((line) => (
                <div
                    key={line.index}
                    style={{
                        color: getLineColor(state, line.index),
                        fontWeight: "bold",
                        marginBottom: "8px",
                    }}
                >
                    {line.title}
                </div>
            ))}
        </div>
    );
};

export default ArticleTranslatorProgress;